import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { SITE } from "@/data/site";

const EASE = [0.76, 0, 0.24, 1];
const TOTAL = 2900;

export default function Preloader() {
  const [show, setShow] = useState(() => {
    try { return sessionStorage.getItem("dl_intro") !== "1"; } catch { return true; }
  });

  useEffect(() => {
    if (!show) return;
    document.body.style.overflow = "hidden";
    const t = setTimeout(() => {
      try { sessionStorage.setItem("dl_intro", "1"); } catch {}
      setShow(false);
      document.body.style.overflow = "";
    }, TOTAL);
    return () => { clearTimeout(t); document.body.style.overflow = ""; };
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div data-testid="site-preloader" className="fixed inset-0 z-[200]" exit={{ opacity: 0 }} transition={{ duration: 0.2 }}>
          {/* Tek parça zarif perde — altın kenar çizgisiyle yukarı sıyrılır */}
          <motion.div
            className="absolute inset-0 bg-[#070707]"
            initial={{ y: 0 }}
            animate={{ y: "-101%" }}
            transition={{ duration: 0.9, delay: 2.0, ease: EASE }}
          >
            <div className="absolute bottom-0 inset-x-0 h-px bg-gradient-to-r from-transparent via-[#d4ad6a] to-transparent" />
            <div className="absolute inset-0 pointer-events-none" style={{ background: "radial-gradient(ellipse 55% 45% at 50% 44%, rgba(212,173,106,0.12) 0%, rgba(212,173,106,0.04) 45%, transparent 72%)" }} />
          </motion.div>

          {/* Sahne içeriği — perdeden biraz önce yukarı süzülür */}
          <motion.div
            className="absolute inset-0 flex flex-col items-center justify-center"
            initial={{ opacity: 1, y: 0 }}
            animate={{ opacity: 0, y: -46 }}
            transition={{ duration: 0.55, delay: 1.78, ease: "easeIn" }}
          >
            {/* Nefes alan altın ışıma */}
            <motion.div
              className="absolute w-[560px] h-[560px] rounded-full pointer-events-none"
              style={{ background: "radial-gradient(circle, rgba(212,173,106,0.17) 0%, rgba(212,173,106,0.05) 42%, transparent 70%)" }}
              initial={{ opacity: 0, scale: 0.55 }}
              animate={{ opacity: [0, 1, 0.75, 1], scale: [0.55, 1.08, 1.0, 1.06] }}
              transition={{ duration: 2.2, ease: "easeOut", times: [0, 0.4, 0.7, 1] }}
            />

            {/* Logo — derinlikten netleşerek yükselir */}
            <div className="relative">
              <motion.img
                src={SITE.logoUrl}
                alt="Diamond Life"
                className="h-36 md:h-52 w-auto select-none"
                style={{ filter: "drop-shadow(0 0 46px rgba(212,173,106,0.4))" }}
                initial={{ opacity: 0, scale: 0.84, y: 30, filter: "blur(10px)" }}
                animate={{ opacity: 1, scale: 1, y: 0, filter: "blur(0px)" }}
                transition={{ duration: 1.25, delay: 0.12, ease: EASE }}
                draggable={false}
              />
              {/* Işık süpürmesi — sadece logonun pikselleri üzerinde parlar */}
              <motion.div
                className="absolute inset-0 pointer-events-none"
                style={{
                  WebkitMaskImage: `url(${SITE.logoUrl})`,
                  maskImage: `url(${SITE.logoUrl})`,
                  WebkitMaskSize: "contain",
                  maskSize: "contain",
                  WebkitMaskRepeat: "no-repeat",
                  maskRepeat: "no-repeat",
                  WebkitMaskPosition: "center",
                  maskPosition: "center",
                  background: "linear-gradient(105deg, transparent 32%, rgba(255,248,224,0.95) 50%, transparent 68%)",
                  backgroundSize: "260% 100%",
                }}
                initial={{ backgroundPosition: "130% 0" }}
                animate={{ backgroundPosition: "-130% 0" }}
                transition={{ duration: 1.15, delay: 1.0, ease: "easeInOut" }}
              />
            </div>

            {/* Merkezden açılan ince çizgi */}
            <motion.div
              className="mt-9 h-px bg-gradient-to-r from-transparent via-[#b78b48] to-transparent"
              initial={{ width: 0, opacity: 0 }}
              animate={{ width: 230, opacity: 1 }}
              transition={{ duration: 0.85, delay: 0.75, ease: EASE }}
            />

            {/* Alt başlık — maskeden yükselir */}
            <div className="relative overflow-hidden mt-5">
              <motion.p
                className="text-[10px] md:text-[11px] tracking-[0.5em] uppercase text-[#cbb27e] font-light"
                initial={{ y: "125%" }}
                animate={{ y: "0%" }}
                transition={{ duration: 0.7, delay: 0.95, ease: EASE }}
              >
                Bursa Masaj Salonu · Premium Spa
              </motion.p>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
